export const HIDDEN_HIRING_REASON_CODES = [
	'FP3',
	'R3',
	'R3BIS',
	'AC',
	'CDI',
	'CC',
	'D2',
	'R4',
	'EM',
	'T1',
	'T2',
	'A3',
	'MU',
	'MUE',
	'V1',
	'V1BIS',
	'FP1',
	'R1',
	'R1BIS',
	'FP2',
];

export const HIRING_REASON_PRIORITY_ORDER = [
	'A1',
	'R2BIS',
	'FP4',
	'T1BIS',
	'ZR2B',
	'ZA1',
	'ZT1B',
	'ZT2B',
	'T2BIS',
];
